import axios from "../api/api"

export const fetchUser = async (userInfo) => {
  const response = await axios.post("/login", JSON.stringify(userInfo), {
    headers: { "Content-Type": "text/plain",  'Accept': 'application/json, text/plain, */*'},
  });

  return response;
};
